import ltEnhancements from 'html/customize/lt-enhancements.html';
import App from 'app/app.js';

function LtEnhancementsDirective($timeout) {
  var CYOP_PATH = '/cyop';

  return {
    restrict: 'E',
    controller: 'LtEnhancementsCtrl',
    controllerAs: 'ctrl',
    scope: {
      sku: '=',
      options: '=',
      onChange: '&',
      noHeader: '=',
      onBlur: '&'
    },
    template: ltEnhancements,
    link: function (scope, element, attrs, enhancementsCtrl) {
      enhancementsCtrl.init(scope.sku);

      var fireOnChange = function () {
        if (!!scope.onChange) {
          scope.onChange();
        }
      };

      var fireOnBlur = function () {
        if (!!scope.onBlur) {
          scope.onBlur();
        }
      };

      scope.onPersonalizationChanged = function () {
        enhancementsCtrl.onPersonalizationValueChanged();
        fireOnBlur();
      };

      scope.options.isValid = function (canEnableAddToCart) {
        var valid;
        if (!canEnableAddToCart) {
          scope.hasTriedAddingToCart = true;
        }
        enhancementsCtrl.validatePersonalizationData();
        valid = enhancementsCtrl.isValid() && enhancementsCtrl.isPersonalizationDataValid;
        enhancementsCtrl.scrollToError(valid, element);
        return valid;
      };

      scope.options.getSelectedUpgrades = function () {
        return enhancementsCtrl.getSelectedUpgrades();
      };

      scope.options.getSelections = function () {
        var enhancements = [];

        if (enhancementsCtrl.selectedPersonalizationEnhancement) {
          enhancements.push(enhancementsCtrl.selectedPersonalizationEnhancement);
        }

        if (enhancementsCtrl.selectedRetouchingEnhancement) {
          enhancements.push(enhancementsCtrl.selectedRetouchingEnhancement);
        }

        return {
          isPersonalizationEnhancementOptedOut: enhancementsCtrl.optOutOfPersonalizationEnhancement,
          isRetouchingEnhancementOptedOut: enhancementsCtrl.optOutOfRetouchingEnhancement,
          selectedEnhancements: enhancements
        };
      };

      scope.onPersonalizationSelected = function (productCode) {
        if (enhancementsCtrl.selectedPersonalization !== productCode) {
          enhancementsCtrl.selectedPersonalization = productCode;
          enhancementsCtrl.onEnhancementSelected({ productCode: productCode });
          fireOnChange();
        }
      };

      scope.onRetouchingSelected = function (productCode) {
        if (enhancementsCtrl.selectedRetouching !== productCode) {
          enhancementsCtrl.selectedRetouching = productCode;
          enhancementsCtrl.onEnhancementSelected({ productCode: productCode });
          fireOnChange();
        }
      };

      scope.options.recalculateAvailableEnhancements = function (items, initialSelections) {
        enhancementsCtrl.calculateAvailableEnhancements(items, initialSelections);

        if (enhancementsCtrl.getCurrentRoute().includes(CYOP_PATH)) {
          if (!enhancementsCtrl.selectedRetouchingEnhancement) {
            scope.onRetouchingSelected('NO_RETOUCHING_PREFERENCE');
          }
          if (!enhancementsCtrl.selectedPersonalizationEnhancement) {
            scope.onPersonalizationSelected('NO_PERSONALIZATION_PREFERENCE');
          }
        }
      };

      $timeout(function () {
        if (!enhancementsCtrl.selectedRetouchingEnhancement) {
          scope.onRetouchingSelected('NO_RETOUCHING_PREFERENCE');
        }
        if (!enhancementsCtrl.selectedPersonalizationEnhancement) {
          scope.onPersonalizationSelected('NO_PERSONALIZATION_PREFERENCE');
        }
      });
    }
  };
}

App.directive('ltEnhancements', ['$timeout', LtEnhancementsDirective]);
